import { render, staticRenderFns } from "./SectionSelectionSundayReaction.vue?vue&type=template&id=1bf9df9d&"
import script from "./SectionSelectionSundayReaction.vue?vue&type=script&lang=js&"
export * from "./SectionSelectionSundayReaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports